var map = {
	"./camera.svg": "8ce0",
	"./icon-16.svg": "4849a",
	"./icon-17.svg": "c752",
	"./icon-18.svg": "914f",
	"./icon-19.svg": "cd3b",
	"./icon-20.svg": "6936",
	"./icon-21.svg": "3cd9",
	"./icon-arrow.svg": "aa71",
	"./icon-back.svg": "90c4",
	"./icon-btn.svg": "543a",
	"./icon-check.svg": "1d32",
	"./icon-dianchi.svg": "9831",
	"./icon-down.svg": "9cb4",
	"./icon-head-logo.svg": "71d4",
	"./icon-menu-logo.svg": "701b",
	"./icon-notice.svg": "f06d",
	"./icon-page.svg": "e765",
	"./icon-phone-more.svg": "93ff6",
	"./icon-right-arrow.svg": "1a94",
	"./icon-shop-car.svg": "3e7e",
	"./icon-shop-status.svg": "e0f7",
	"./icon-up.svg": "3944",
	"./icon-wifi.svg": "5aa5",
	"./img-default.svg": "34a8",
	"./login-logo.svg": "5df9",
	"./menu-activity.svg": "2e61",
	"./menu-capital.svg": "0228",
	"./menu-content.svg": "7c8c",
	"./menu-customer.svg": "7f73",
	"./menu-goods.svg": "ee96",
	"./menu-helper.svg": "25c8",
	"./menu-index.svg": "9c0f",
	"./menu-logistics.svg": "600b",
	"./menu-marketing.svg": "f7f6",
	"./menu-order.svg": "3c8f",
	"./menu-partner.svg": "58b9",
	"./menu-shop.svg": "5a6c",
	"./menu-staff.svg": "5c73",
	"./qrcode-icon.svg": "b746",
	"./settled-success.svg": "e88e",
	"./tax.svg": "c3dc",
	"./warn.svg": "f809"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fce";